// extracted by mini-css-extract-plugin
export default {"heading":"EducationSection_heading__05mg+","content":"EducationSection_content__sCnzj"};